import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=069fbf82&scoped=true"
import script from "./TableBase.vue?vue&type=script&lang=js"
export * from "./TableBase.vue?vue&type=script&lang=js"
import style0 from "./TableBase.vue?vue&type=style&index=0&id=069fbf82&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069fbf82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('069fbf82')) {
      api.createRecord('069fbf82', component.options)
    } else {
      api.reload('069fbf82', component.options)
    }
    module.hot.accept("./TableBase.vue?vue&type=template&id=069fbf82&scoped=true", function () {
      api.rerender('069fbf82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableBase.vue"
export default component.exports